import CityPageTemplate from "../city-template/CityPageTemplate";
import { daytonConfig } from "./data";

export default function DaytonPage() {
  return <CityPageTemplate config={daytonConfig} />;
}